import * as React from 'react';
import { useIsomorphicLayoutEffect } from '@cian/react-utils';
import { throttle } from 'throttle-debounce';

import { SCROLL_THROTTLE_DELAY } from '../../constants/delays';

interface IParameters {
  containerRef: React.RefObject<HTMLElement | null>;
  fallbackRef: React.RefObject<HTMLElement | null>;
}

export const useSticky = ({ containerRef, fallbackRef }: IParameters): boolean => {
  const [sticky, setSticky] = React.useState(false);

  const handleSticky = React.useCallback(() => {
    const currentRef = containerRef.current ? containerRef : fallbackRef;

    if (currentRef && currentRef.current) {
      const { bottom } = currentRef.current.getBoundingClientRect();
      const sticky = bottom < 0;
      setSticky(sticky);
    }
  }, [containerRef, fallbackRef]);

  useIsomorphicLayoutEffect(() => {
    handleSticky();

    const throttledScrollHandler = throttle(SCROLL_THROTTLE_DELAY, handleSticky);
    window.addEventListener('scroll', throttledScrollHandler);

    return () => {
      window.removeEventListener('scroll', throttledScrollHandler);
    };
  }, [handleSticky]);

  return sticky;
};
